module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_4000_Active@1x-d9e98a5ba5698fd1d5b0e0cb7ba67377.png";